import ReactPlayer from 'react-player';
import cx from 'classnames';

import LinkPreview from 'components/LinkPreview/LinkPreview';
import CauzeVideo from 'components/CauzeVideo/CauzeVideo';

const FeedCardPreview = ({ previewUrl, video, videoName }) => {
  const isVideo =
    video || previewUrl?.includes('youtu') || previewUrl?.includes('vimeo');
  const isShorts = previewUrl?.includes('shorts');

  if (video) {
    return (
      <div className="flex flex-1 justify-center mb-3">
        <CauzeVideo video={video} videoName={videoName} maxWidth={240} />
      </div>
    );
  }

  if (isVideo) {
    return (
      <div className="flex justify-center flex-1">
        <div className="video-container pb-2">
          <div
            className={cx('event-video', {
              'h-[600px] rounded-[10px] overflow-hidden': isShorts,
            })}
          >
            <ReactPlayer
              width="100%"
              height="100%"
              controls
              playsInline
              src={video?.videoUrl || previewUrl}
            />
          </div>
        </div>
      </div>
    );
  }

  return <LinkPreview uri={previewUrl} />;
};

export default FeedCardPreview;
